import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { type AttributeOptionsType } from '../queries';
import { setLeadSourceOptions } from '../stores';

export interface GetLeadAttributeOptionsType {
  leadAttributeOptions: AttributeOptionsType[];
}

export const getLeadSources = `
  query getLeadSource {
    leadAttributeOptions: leadSources {
      value: leadSourceUuid
      label: name
    }
  }
`;

const useFetchLeadSourceOptions = ({ skip = false }: { skip?: boolean } = {}) => {
  const dispatch = useDispatch();

  const [fetchLeadSourceOptions,
    { data: leadSourceOptions, isLoading },
  ] = useLazyIndexedDBGraphqlQuery<GetLeadAttributeOptionsType>({
    cacheKey: 'leadSourceOptions',
    document: getLeadSources,
  });

  useEffect(() => {
    if (!skip && !isLoading && !leadSourceOptions) {
      fetchLeadSourceOptions({ document: getLeadSources });
    }
  }, [fetchLeadSourceOptions, skip, leadSourceOptions, isLoading]);

  useEffect(() => {
    if (leadSourceOptions?.leadAttributeOptions) {
      dispatch(setLeadSourceOptions({ data: leadSourceOptions.leadAttributeOptions }));
    }
  }, [leadSourceOptions, dispatch]);

  return {
    fetchLeadSourceOptions,
    leadSourceOptions,
    isLoading,
  };
};

export default useFetchLeadSourceOptions;
